$(document).ready(function () {
    if ($('.dnBusinessTestimonials').length) {

        var container = $('.dnBusinessTestimonials');

        container.find('.carousel').carousel({
            interval: false
        });

        var interval = getInterval();

        container.hover(
            function () {
                clearInterval(interval);
            },
            function () {
                interval = getInterval();
            }
        );

        $(document).on('click', '.dnBusinessTestimonials-img', function () {
            var ids = $(this).data('ids');
            var len = ids.length;
            var id = null;
            var img = $(this).data('key');

            for (var i = 0; i < len; i++) {
                id = ids[i];
                $(id).carousel(img);
            }

            $('.dnBusinessTestimonials-img').removeClass('dnBusinessTestimonials-img-active');
            $(this).addClass('dnBusinessTestimonials-img-active');
        });

        function getInterval() {
            return setInterval(
                function () {
                    var a = $('#testimonialsImage .active').index();
                    var c = $('#testimonialsImage .carousel-item').length;
                    var e = a + 1;

                    if (c == e) {
                        e = 0;
                    }

                    $('#testimonialsImage').carousel('next');
                    $('#testimonialsText').carousel('next');

                    $('.dnBusinessTestimonials-img').removeClass('dnBusinessTestimonials-img-active');
                    $('.dnBusinessTestimonials-img').eq(e).addClass('dnBusinessTestimonials-img-active');
                }, 5000
            );
        }
    }
});